import React from "react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import BotonBorrar from "../../shared/botones/BotonBorrar";

class TablaAlumnos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      column: null,
      data: this.props.listaAlumnos,
      direction: null
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      data: nextProps.listaAlumnos
    });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Table sortable striped compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={column === "nombre" ? direction : null}
              onClick={this.handleSort("nombre")}
            >
              Nombre
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "apellido1" ? direction : null}
              onClick={this.handleSort("apellido1")}
            >
              Primer Apellido
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "apellido2" ? direction : null}
              onClick={this.handleSort("apellido2")}
            >
              Segundo Apellido
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "edad" ? direction : null}
              onClick={this.handleSort("edad")}
            >
              Edad
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "contacto.nombre" ? direction : null}
              onClick={this.handleSort("contacto.nombre")}
            >
              Contacto
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "contacto.telefono" ? direction : null}
              onClick={this.handleSort("contacto.telefono")}
            >
              Contacto
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "colegioestudios.nombre" ? direction : null}
              onClick={this.handleSort("colegioestudios.nombre")}
            >
              Colegio
            </Table.HeaderCell>
            {this.props.editable && <Table.HeaderCell />}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {_.map(data, d => (
            <Table.Row key={d.id}>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {d.nombre}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {d.apellido1}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {d.apellido2}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {d.edad}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {!_.isEmpty(d.contacto) ? d.contacto.nombre : ""}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {!_.isEmpty(d.contacto) ? d.contacto.telefono : ""}
              </Table.Cell>
              <Table.Cell onClick={() => this.props.handleRowClick(d.id)}>
                {!_.isEmpty(d.colegioestudios) ? d.colegioestudios.nombre : ""}
              </Table.Cell>
              {this.props.editable && (
                <Table.Cell>
                  <BotonBorrar
                    data={d.id}
                    handleClick={this.props.handleBorrarAlumno}
                    headerText={`Eliminar Alumno`}
                    content={`¿Desea eliminar a ${d.nombre} ${d.apellido1} ${
                      d.apellido2
                    }
                    de la base de datos?`}
                  />
                </Table.Cell>
              )}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

TablaAlumnos.defaultProps = {
  editable: false
};

TablaAlumnos.propTypes = {
  handleBorrarAlumno: PropTypes.func,
  handleRowClick: PropTypes.func,
  listaAlumnos: PropTypes.array.isRequired,
  editable: PropTypes.bool
};

export default TablaAlumnos;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoAlumnos/TablaAlumnos.jsx